import { styled, Stack, Text } from '@withjoy/joykit';

export const StackWrapper = styled(Stack)`
  align-items: center;
`;

export const Subtitle = styled(Text)`
  text-align: center;
  width: 80%;
  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    width: 60%;
  }
`;
